module.exports = __webpack_public_path__ + "img/Flag_of_the_Falkland_Islands.098b9e64.svg";